(() => {
  if (customElements.get('hx-faq-accordion')) return;
  customElements.define('hx-faq-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.items = new Map();
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.hx-product-richtext');
        const state = { expanded: details.open };
        this.items.set(details, state);
        details.dataset.faqExpanded = String(state.expanded);
        summary.addEventListener('click', event => {
          event.preventDefault();
          const start = details.getBoundingClientRect().height;
          state.animation?.cancel();
          state.contentAnimation?.cancel();
          state.expanded = !state.expanded;
          details.dataset.faqExpanded = String(state.expanded);
          summary.setAttribute('aria-expanded', String(state.expanded));
          if (this.motion.matches) { details.open = state.expanded; return; }
          details.open = true;
          const border = parseFloat(getComputedStyle(details).borderTopWidth) + parseFloat(getComputedStyle(details).borderBottomWidth);
          const end = state.expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
          const animation = details.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 330, easing: 'cubic-bezier(.22,.68,.2,1)' });
          state.animation = animation;
          state.contentAnimation = content?.animate(state.expanded ? [{ opacity: 0, transform: 'translateY(7px)' }, { opacity: 1, transform: 'translateY(0)' }] : [{ opacity: 1 }, { opacity: 0 }], { duration: state.expanded ? 300 : 180, easing: 'ease-out' });
          animation.onfinish = () => {
            if (state.animation !== animation) return;
            details.open = state.expanded;
            state.animation = null;
          };
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.items?.forEach((state, details) => { state.animation?.cancel(); state.contentAnimation?.cancel(); details.open = state.expanded; });
    }
  });
})();
